import React, { useEffect, useState } from 'react'
import propTypes from 'prop-types';
import { Tooltip } from "flowbite-react"
import DatePicker from 'react-datepicker';
import { Typography, Skeleton } from '..';
import moment from 'moment';
import { ManIcon } from '../../../theme/icons';
import { tooltipTheme } from '../../../theme/flowbite.custom.theme';
import "./index.css"
import { hexToRgba, trimColor } from '../../../utils/infoDetails';
import { useSelector } from 'react-redux';

const formatWeekDay = (name) => <div className={`h-[23px] w-[23px] rounded-4 flex justify-center items-center`} ><Typography className={'text-secondary-400 w-full'} variant="sm" text={name?.substring(0, 1)?.toUpperCase()} /></div>

export const CustomCalendar = React.memo(({ year, selectedMilestones, index, month, off_days, loader }) => {
    const [startDate, setStartDate] = useState(new Date(year, month));
    const { templateUsers } = useSelector(state => state?.SLA)
    const checkDate = ({ _date }) => {
        const offDays = off_days?.length ? off_days?.split(',') : [];
        const today = moment(_date).format('MM-DD-YYYY');
        const day = moment(_date).format('dddd');
        const isoffDay = Boolean(offDays?.includes(day?.substring(0, 3)?.toLowerCase()));
        const selected = (selectedMilestones?.length && selectedMilestones?.findLast(e => String(e?.date) === String(today))) || { borderColor: '', color_code: '' }
        const { date, color_code } = selected;

        const bgColor = selectedMilestones?.length && selectedMilestones?.filter(e => String(e?.date) === String(today))?.map((e => hexToRgba(trimColor(e?.color_code))))

        const backgroundColors = bgColor?.length > 1 ? `linear-gradient(to right, ${bgColor?.map(e => e)})` : hexToRgba(trimColor(color_code))

        return Boolean(String(today) === String(date)) ? {
            background: backgroundColors,
            borderRadius: 50, color: 'white'
        } : isoffDay ? { color: '#A3B3C8' } : {};
    }

    const checkMultipleDates = ({ _date }) => {
        const today = moment(_date).format('MM-DD-YYYY');
        return (selectedMilestones?.length && selectedMilestones?.filter(e => String(e?.date) === String(today))) || [];
    }

    const getUserName = (id) => (templateUsers?.length && templateUsers?.find(e => e?._id === id)?.name) || ""

    const renderDayContents = (day, date) => {
        const isPopover = Boolean(Object.keys(checkDate({ _date: date }))?.length)
        const multipleDates = [...checkMultipleDates({ _date: date })] || [];
 
        const TooltipComponent = () => {
            return (<div className="drop-shadow flex bg-white border w-max text-secondary-400 border-secondary-100 rounded-md max-w-sm p-2">
                <div className='p-1'>
                    <div className='flex justify-between items-center w-full'>
                        <Typography variant="md" className="text-left font-bold text-secondary-600" text={`${day} ${date?.toLocaleString("default", { month: "long" })}`} />
                    </div>
                    <ul className='flex flex-col gap-2 max-h-[40vh] overflow-auto p-2 px-4 min-w-[200px]'>
                        {!!multipleDates?.length && multipleDates?.map((milestone, index) =>
                            <li key={milestone?.value} className='flex flex-col'>
                                <div className='flex items-center gap-2'>
                                    <span style={{ borderColor: trimColor(milestone?.borderColor) }} className={`h-[20px] w-[20px] min-w-[20px] p-[3px] flex justify-center items-center rounded-full border-2  ${milestone?.borderColor}`}>
                                        <span style={{ backgroundColor: trimColor(milestone?.color_code) }} className={`inline-block m-auto rounded-full h-full w-full ${milestone.color_code}`} />
                                    </span>
                                    <div className='text-sm text-secondary-500'>
                                        {milestone?.value}
                                    </div>
                                </div>
                                {milestone?.owner && <div className='ml-5 flex items-center justify-start gap-2'>
                                    <ManIcon />
                                    <Typography className="text-[11px]" text={String(milestone?.owner) || ""} />
                                </div>}
                                {milestone?.assignedUser && <div className='ml-5 flex items-center justify-start gap-2'>
                                     Assigned to : 
                                    <Typography className="text-[11px]" text={getUserName(milestone?.assignedUser) || ""} />
                                </div>}
                            </li>)}
                    </ul>
                </div>
            </div>)
        }

        return (
            <>
                {loader ? <Skeleton length={1} className="w-[25px] h-[25px] m-auto flex justify-center rounded-sm" /> : !isPopover ?
                    <div className='p-0 rounded-full float-right  w-full flex items-center flex-col justify-evenly h-full'>
                        <div className={`w-[25px] h-[25px] m-auto flex justify-center text-[11px] text-secondary-600 items-center`} style={checkDate({ _date: date })} >{day}</div>
                    </div> :
                    <Tooltip placement="left" theme={tooltipTheme} content={!!multipleDates?.length ? <TooltipComponent /> : ""}>
                        <div className='p-0 rounded-full float-right  w-full flex items-center flex-col justify-evenly h-full '>
                            <div id={moment(date)?.format("MM-DD-YYYY")} className={`w-[25px] h-[25px] m-auto flex justify-center text-[11px] text-secondary-600 items-center`} style={checkDate({ _date: date })} >{day}</div>
                        </div>
                    </Tooltip>

                }
            </>
        )
    };

    useEffect(() => {
        setStartDate(new Date(year, month))
    }, [year, month])

    return (
        <div className={`all-day-calandar relative`} style={{ zIndex: 120 + index, width: 'fit-content', "pageBreakInside": 'avoid', "pageBreakAfter": 'auto' }}>
            <DatePicker
                selected={startDate}
                renderDayContents={renderDayContents}
                formatWeekDay={formatWeekDay}
                minDate={new Date(year, month, 1)}
                maxDate={new Date(year, month + 1, 0)}
                onChange={(date) => setStartDate(date)}
                inline
                renderCustomHeader={({ date, }) => (<div className='pl-2 my-2'>
                    <Typography className="text-left font-semibold" variant="sm"
                        text={date?.toLocaleString("default", { month: "long" })} />
                </div>)}
            />
        </div>
    );
});

CustomCalendar.propTypes = {
    year: propTypes.number,
    date: propTypes.instanceOf(Date),
    milestones: propTypes.array,
    off_days: propTypes.string
}

CustomCalendar.defaultProps = {
    year: new Date().getFullYear(),
    date: new Date(),
    milestones: [],
    off_days: ""
}